export const DEFAULT_TOLERENCE = 0.005;

export function compareWithTolerance(
  a: number,
  b: number,
  tolerance: number = DEFAULT_TOLERENCE
): boolean {
  return Math.abs(a - b) <= tolerance;
}

export function compareMoreThanEqualsWithTolerance(
  a: number,
  b: number,
  tolerance: number = DEFAULT_TOLERENCE
): boolean {
  if (compareWithTolerance(a, b, tolerance)) {
    return true;
  }
  return a >= b;
}

export function compareLessThanEqualsWithTolerance(
  a: number,
  b: number,
  tolerance: number = DEFAULT_TOLERENCE
): boolean {
  if (compareWithTolerance(a, b, tolerance)) {
    return true;
  }
  return a <= b;
}

export function compareMoreThanWithTolerance(
  a: number,
  b: number,
  tolerance: number = DEFAULT_TOLERENCE
): boolean {
  return a - b > tolerance;
}

export function compareLessThanWithTolerance(
  a: number,
  b: number,
  tolerance: number = DEFAULT_TOLERENCE
): boolean {
  return a - b < tolerance;
}
